module.exports = __webpack_public_path__ + "static/ability-mobileimg-0ca1a2683622dae9f3c14453bbf4a21c.png";